import { render, staticRenderFns } from "./korean_iframe.vue?vue&type=template&id=79ce6523&scoped=true"
import script from "./korean_iframe.vue?vue&type=script&lang=js"
export * from "./korean_iframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ce6523",
  null
  
)

export default component.exports